if (!window.pingInit) window.pingInit = {};

window.pingInit.initAccordions = (selector = null) => {
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion-content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      if (!this.el.dataset.index) {
        this.el.dataset.index = new Date().getTime();
      }
      this.dataIndex = this.el.dataset.index;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    getCSSValue(el, prop) {
      if(!el || !prop) return;
      if (getComputedStyle(el)[prop]) {
        return parseInt(getComputedStyle(el)[prop].replace('px', ''));
      } else {
        return 0;
      }
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.getCSSValue(this.el, 'border-top') + this.getCSSValue(this.el, 'border-bottom')}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 800,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
      if (this.el.classList.contains('filter__disclosure')) {
        $('details.filter__disclosure[open]:not([data-index="' + this.dataIndex + '"]) summary').trigger('click');
      }
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight + this.getCSSValue(this.el, 'border-top') + this.getCSSValue(this.el, 'border-bottom')}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll(selector ? selector : 'details').forEach((el) => {
    if (el.querySelector('summary') && el.querySelector('.accordion-content')) {
      new Accordion(el);
    }
  });
}

window.pingInit.initAccordions();
